// 1. Definição do Enum numérico
export enum AnexoTipo {
  GENERICO = 1,
  PARECER_JURIDICO = 2,
  EXTRATO_PORTARIA = 3,
  EXTRATO_JULGAMENTO = 4,
  EXTRATO_JULGAMENTO_RECURSO = 5,
  EDITAL_INTIMACAO = 6,
  DOCUMENTO_DEFESA = 7,
}

// 2. Mapeamento para os Labels (útil para exibir na interface)
export const AnexoTipoLabels: Record<AnexoTipo, string> = {
  [AnexoTipo.GENERICO]: 'Anexo Genérico',
  [AnexoTipo.PARECER_JURIDICO]: 'Parecer Jurídico',
  [AnexoTipo.EXTRATO_PORTARIA]: 'Extrato de Publicação da Portaria',
  [AnexoTipo.EXTRATO_JULGAMENTO]: 'Extrato de Publicação de Julgamento',
  [AnexoTipo.EXTRATO_JULGAMENTO_RECURSO]: 'Extrato de Publicação de Julgamento do Recurso',
  [AnexoTipo.EDITAL_INTIMACAO]: 'Publicação de Edital de Intimação',
  [AnexoTipo.DOCUMENTO_DEFESA]: 'Documento da Defesa',
};

// 3. Se você ainda precisar da lista original para um componente de <select> (Combobox)
export const AnexoTipoOption = Object.entries(AnexoTipoLabels).map(([value, label]) => ({
  value: Number(value),
  label,
}));
